module.exports = __webpack_public_path__ + "media/images/close_compare_button-72f4cbc03e80e1bd89ffccbc2fa45f49.svg";